import Konva from "konva";

export const ART_WIDTH = 1920;
export const ART_HEIGHT = 1080;

export function createArtExportStage() {
  return new Konva.Stage({
    container: document.createElement("div"),
    width: ART_WIDTH,
    height: ART_HEIGHT,
  });
}

export function rasterizeArtNode(
  stage: Konva.Stage,
  node: Konva.Group | Konva.Shape,
  padding = 0,
) {
  const isolation = new Konva.Layer({ listening: false });
  stage.add(isolation);
  try {
    const clone = node.clone();
    isolation.add(clone);
    const bounds = clone.getClientRect();
    const left = Math.floor(bounds.x - padding);
    const top = Math.floor(bounds.y - padding);
    const right = Math.ceil(bounds.x + bounds.width + padding);
    const bottom = Math.ceil(bounds.y + bounds.height + padding);
    const width = Math.max(1, right - left);
    const height = Math.max(1, bottom - top);
    const canvas = isolation.toCanvas({
      x: left,
      y: top,
      width,
      height,
      pixelRatio: 1,
    });
    return { canvas, left, top, right: left + width, bottom: top + height };
  } finally {
    isolation.destroy();
  }
}
